/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetReplyChildsQuery } from '../../models/get-reply-childs-query';
import { GetReplyChildsQueryResult } from '../../models/get-reply-childs-query-result';

export interface ApiKpiReportsGetReplyChildsPost$Plain$Params {
      body?: GetReplyChildsQuery
}

export function apiKpiReportsGetReplyChildsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpiReportsGetReplyChildsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetReplyChildsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsGetReplyChildsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetReplyChildsQueryResult>;
    })
  );
}

apiKpiReportsGetReplyChildsPost$Plain.PATH = '/api/KPIReports/GetReplyChilds';
